<template>
  <div id="mockList" class="container">
    <!--    <progress-bar :show="this.loading" color="primary" type="full"></progress-bar>-->
    <mock-print
      :selected_mock.sync="selected_mock"
      @close="dialog = false"
      :dialog.sync="dialog"
    ></mock-print>
    <v-container grid-list-xl fluid style="max-width: 1000px">
      <v-layout row wrap>
        <v-flex sm12>
          <h2>Simulados</h2>
        </v-flex>
        <v-flex
          v-flex
          xs12
          sm6
          lg4
          v-for="mock in loading ? [1, 2, 3] : mocks"
          :key="mock.id || mock"
        >
          <v-skeleton-loader
            v-if="loading"
            transition="scale-transition"
            height="320"
            type="card"
          ></v-skeleton-loader>
          <v-card v-else @click="startMock(mock)" class="rounded-xl">
            <v-img
              :src="mock.image"
              height="200px"
              style="background-color: darkslateblue"
            >
            </v-img>
            <div
              class="pa-5"
              style="display: flex; flex-direction: column; gap: 15px"
            >
              <div style="display: flex; align-items: center">
                <h3 style="font-weight: bold; margin-left: 3px">
                  {{ mock.title }}
                </h3>
                <v-spacer></v-spacer>
                <v-btn text icon @click.stop="printMock(mock)">
                  <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M18,3H6V7H18M19,12A1,1 0 0,1 18,11A1,1 0 0,1 19,10A1,1 0 0,1 20,11A1,1 0 0,1 19,12M16,19H8V14H16M19,8H5A3,3 0 0,0 2,11V17H6V21H18V17H22V11A3,3 0 0,0 19,8Z"
                    />
                  </svg>
                </v-btn>
                <v-btn text icon @click.stop="mockShare(mock)">
                  <v-icon>share</v-icon>
                </v-btn>
              </div>
              <!-- <span class="grey--text">
                  {{mock.description}}
                </span> -->
              <v-btn
                rounded
                elevation="0"
                color="primary"
                style="width: 100%; font-size: 16px"
                @click="startMock(mock)"
                >Resolver</v-btn
              >
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import MockService from "@/services/mocks.service";
import MockPrint from "../../components/quiz/MockPrint.vue";

export default {
  components: { MockPrint },
  mounted() {},
  data() {
    return {
      mocks: [{}, {}, {}, {}],
      loading: true,
      selected_mock: null,
      dialog: false,
    };
  },
  created() {
    this.loading = true;
    MockService.getListPublic({ orderBy: "order" })
      .then((resp) => {
        this.mocks = resp.data;
        this.loading = false;
      })
      .catch((ex) => {
        window.getApp.sendSnackMessage(ex.message, "error");
        this.loading = false;
      });
  },
  methods: {
    async printMock(mock) {
      const query = {};
      this.dialog = true;
      query.include = "questions";
      console.log(mock, this.dialog);
      const res = await MockService.getByIdPublic(mock.id, query);
      console.log(res);
      this.selected_mock = res.data;
    },
    startMock(mock) {
      this.$router.push({ name: "mocks.start", params: { id: mock.id } });
    },
    mockShare(mock) {
      window.getApp.share(
        mock.title,
        mock.description,
        process.env.MIX_APP_URL + "/mocks/" + mock.id,
      );
    },
  },
};
</script>
